import { render, staticRenderFns } from "./IndustryCatagory.vue?vue&type=template&id=998d69a8&scoped=true&"
import script from "./IndustryCatagory.vue?vue&type=script&lang=js&"
export * from "./IndustryCatagory.vue?vue&type=script&lang=js&"
import style0 from "./IndustryCatagory.vue?vue&type=style&index=0&id=998d69a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998d69a8",
  null
  
)

export default component.exports